import React from "react";

// components

import CardStats from "../../components/Cards/CardStats.js";

export default function HeaderStats({solicitudesT,solicitudesP,equiposT, equiposP, criticosT,
   criticosP, implementaT, implementaP}) {
  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-12 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL SOLICITUDES"
                  statTitle={ solicitudesT.toString() }
                  statArrow={ ((solicitudesP/solicitudesT) * 100 ) >= 50 ? "down" :"up"}
                  statNumber= {solicitudesP}
                  statPercent={solicitudesT > 0 ? (((solicitudesP / solicitudesT) * 100).toFixed(2)).toString() : "0"}
                  statPercentColor= { ((solicitudesP/solicitudesT) * 100 ) >= 50 ? "text-red-500" :"text-emerald-500"}
                  statDescripiron="En Proceso"
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="EQUIPOS SOLICITADOS"
                  statTitle={equiposT}
                  statArrow={ ((equiposP/equiposT) * 100 ) >= 50 ? "down" :"up"}
                  statNumber= {equiposP}
                  statPercent={equiposT > 0 ? ((equiposP/equiposT) * 100 ).toFixed(2) : 0}
                  statPercentColor={ ((equiposP/equiposT) * 100 ) >= 50 ? "text-red-500" :"text-emerald-500"}
                  statDescripiron="Pendientes"
                  statIconName="fas fa-chart-pie"
                  statIconColor="bg-orange-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="EQUIPOS CRÍTICOS"
                  statTitle={criticosT}
                  statArrow={ ((criticosP/criticosT) * 100 ) >= 50 ? "down" :"up"}
                  statNumber= {criticosP}
                  statPercent={criticosT > 0 ? ((criticosP/criticosT) * 100 ).toFixed(2) : 0}
                  statPercentColor={ ((criticosP/criticosT) * 100 ) >= 50 ? "text-red-500" :"text-emerald-500"}
                  statDescripiron="Pendientes"
                  statIconName="fas fa-users"
                  statIconColor="bg-pink-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL IMPLEMENTAR"
                  statTitle={implementaT}
                  statArrow={ ((implementaP/implementaT) * 100 ) >= 50 ? "down" :"up"}
                  statNumber={implementaP}
                  statPercent={implementaT > 0 ? ((implementaP/implementaT) * 100 ).toFixed(2) : 0}
                  statPercentColor={ ((implementaP/implementaT) * 100 ) >= 50 ? "text-red-500" :"text-emerald-500"}
                  statDescripiron="por implementar"
                  statIconName="fas fa-percent"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
